import { SPACE_TYPE } from 'modules/security/users/constants/space-types.constants';

export enum ROLE_PERMISSIONS {
  ROLE_VIEW = 'ROLE_VIEW',

  ROLE_ADMINVIEW = 'ROLE_ADMINVIEW',
  ROLE_ADMINWRITE = 'ROLE_ADMINWRITE',

  ROLE_PROVIDERVIEW = 'ROLE_PROVIDERVIEW',
  ROLE_PROVIDERWRITE = 'ROLE_PROVIDERWRITE',

  ROLE_PUBLICVIEW = 'ROLE_PUBLICVIEW',
  ROLE_PUBLICWRITE = 'ROLE_PUBLICWRITE',
}

export const getRolePermissionWrite = (type: SPACE_TYPE) => {
  switch (type) {
    case SPACE_TYPE.PROVIDER:
      return ROLE_PERMISSIONS.ROLE_PROVIDERWRITE;
    case SPACE_TYPE.ROOT:
      return ROLE_PERMISSIONS.ROLE_ADMINWRITE;
    case SPACE_TYPE.PUBLIC:
      return ROLE_PERMISSIONS.ROLE_PUBLICWRITE;
  }
};
